import React, {Component} from 'react';
import {Link} from 'react-router'
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as promoCodeActions from '../../../actions/promo-codes';
import DataTable from '../../../components/data-table/data-table';
import LocalizedStrings from '../../../localization/strings';

class PromoCodesContainer extends Component {

    componentWillMount() {
        this.fetch({});
    }
    removeItem(post) {
        if (confirm(LocalizedStrings.doYouWantToRemove)) {
            this.props.actions.deletePromoCode(post);
        }
    }

    fetch(params) {
        const fetchParams = {
            ...this.state,
            ...params
        }
        this.setState(fetchParams);
        this.props.actions.fetchPromoCodesPaginated(fetchParams.page, fetchParams.size);
    }

    render() {
        const {items, total, page, loading, total_pages} = this.props.promoCodes;

        var config = {
            cols: [
                {
                    value: 'code',
                    header: LocalizedStrings.code
                }, {
                    value: 'codes_left',
                    header: LocalizedStrings.codesLeft
                }, {
                    value: (item) => {
                        return (
                            <div className="btn-group">
                                <Link to={`/admin/promo-codes/${item.id}`} className="btn">
                                    {LocalizedStrings.edit}
                                </Link>
                                <a className="btn btn-red" onClick={this.removeItem.bind(this, item)}>
                                    {LocalizedStrings.delete}
                                </a>
                            </div>
                        )
                    },
                    header: LocalizedStrings.actions
                }
            ]
        };
        return (
            <div>
                <h3>
                    {LocalizedStrings.promoCodes}
                </h3>
                <div className="table-actions-row">
                    <Link to="/admin/promo-codes/new" className="btn btn-primary">
                        {LocalizedStrings.newPromoCode}
                    </Link>
                </div>
                <div className="panel">
                    <div className="panel-body">
                        <DataTable loading={loading} config={config} items={items} page={page} total={total} totalPages={total_pages} loadAction={this.fetch.bind(this)}></DataTable>
                    </div>
                </div>
            </div>

        )
    }
}

export default connect(function(state) {
    return {promoCodes: state.promoCodes.promoCodes};
}, function(dispatch) {
    return {
        actions: bindActionCreators({
            ...promoCodeActions
        }, dispatch)
    };
})(PromoCodesContainer);



// WEBPACK FOOTER //
// ./src/js/containers/admin/promo-codes/promo-codes-container.js